function initDropdown(){
  var dropdowns = document.querySelectorAll('.dropdown');
  if(dropdowns){
    dropdowns.forEach(function(el){
      var button = el.querySelector('button');
      if(button){
        button.addEventListener('click',function(e){
          el.classList.toggle('open');
          var ariaExpanded = button.getAttribute('aria-expanded');
          ariaExpanded = ariaExpanded=='true'?false:true;
          button.setAttribute('aria-expanded',ariaExpanded);
        });
      }
    });
  }

  document.addEventListener('click', function(e){
    if(e.target.tagName!='A' && !e.target.parentNode.classList.contains('dropdown')){
      dropdowns.forEach(function(el){
        el.classList.remove('open');
      });
    }
  });
}

function initSlider(startSlide = 0){
  
  var options = {
    startSlide: startSlide,
    //auto: 3000,
    draggable: true,
    autoRestart: false,
    continuous: true,
    disableScroll: true,
    stopPropagation: true,
    callback: function(index, element) {},
    transitionEnd: function(index, element) {}
  };
  
  var slider = document.getElementById('slider');
  window.mySwipe = new Swipe(slider, options);
  
  var prev = document.querySelector('.swipe-nav.prev');
  if(!prev){
    prev = document.createElement('span');
    prev.className = 'swipe-nav prev';
    prev.innerHTML = 'Précedent';
    prev.addEventListener('click', function(){
      window.mySwipe.prev();
    });
    slider.appendChild(prev);

    var next = document.createElement('span');
    next.className = 'swipe-nav next';
    next.innerHTML = 'Suivant';
    next.addEventListener('click', function(){
      window.mySwipe.next();
    });
    slider.appendChild(next);
  }

}

function initStuffs(){
  // stuffs...
  var mno = /EMckd54fRd/gi;
  var xyz = 'viEMckd54fRdncent@viEMckd54fRdpere-musiEMckd54fRdque.EMckd54fRdfEMckd54fRdrEMckd54fRd';
  xyz = xyz.replace(mno,'');
  var abc = '0EMckd54fRd6EMckd54fRd 79EMckd54fRd 8EMckd54fRd2EMckd54fRd EMckd54fRd60EMckd54fRd 2EMckd54fRd2';
  abc = abc.replace(mno,'');
  document.getElementById('xyz').innerHTML = `<a href="mailto:${xyz}">${xyz}</a>`;
  document.getElementById('abc').innerHTML = `<a href="mailto:${abc}">${abc}</a>`;
}

function initScrollSpy(){
  var menu = document.querySelectorAll('#navigation li');

  // for clickable event
  menu.forEach(function(v) {
    v.onclick = function(){
      setTimeout(function(){
        menu.forEach(function(j){
          j.classList.remove('active');
        });
        v.classList.add('active');
      },300);
    };
  });

  // for window scrolldown event
  window.onscroll = function() {
    var mainSection = document.querySelectorAll('body > section');

    mainSection.forEach(function(v,i){
      var rect = v.getBoundingClientRect().y;
      //if(rect < window.innerHeight-200){
      if(rect <= 0 && rect > -1*window.innerHeight){
        menu.forEach(v=> v.classList.remove('active'));
        menu[i].classList.add('active');

        document.querySelector('body').className = menu[i].querySelector('a').getAttribute('href').replace('#','');
      }
    });
  };
}

function initIframes(){
  /*var player1 = document.getElementById('player1');
  player1.querySelector('picture').addEventListener('mouseover', function(){
    player1.innerHTML = '<span class="loader">Chargement en cours...</span><iframe title="En parachute by Vipère" style="border: 0; width: 100%; height: 42px;" src="https://bandcamp.com/EmbeddedPlayer/track=1698232823/size=small/bgcol=ffffff/linkcol=0687f5/transparent=true/" seamless><a href="http://vipereduo.bandcamp.com/track/en-parachute" rel="noopener">En parachute by Vipère</a></iframe>';
  });//*/

  /*var player2 = document.getElementById('player2');
  player2.querySelector('picture').addEventListener('mouseover', function(){
    player2.innerHTML = '<span class="loader">Chargement en cours...</span><iframe title="Le loup by Vipère" style="border: 0; width: 100%; height: 42px;" src="https://bandcamp.com/EmbeddedPlayer/track=2551148491/size=small/bgcol=ffffff/linkcol=0687f5/transparent=true/" seamless><a href="http://vipereduo.bandcamp.com/track/le-loup" rel="noopener">Le loup by Vipère</a></iframe>';
  });//*/

  /*var player3 = document.getElementById('player3');
  player3.querySelector('picture').addEventListener('mouseover', function(){
    player3.innerHTML = '<span class="loader">Chargement en cours...</span><iframe title="Mascarade by Vipère" style="border: 0; width: 100%; height: 42px;" src="https://bandcamp.com/EmbeddedPlayer/track=1243958258/size=small/bgcol=ffffff/linkcol=0687f5/transparent=true/" seamless><a href="http://vipereduo.bandcamp.com/track/mascarade" rel="noopener">Mascarade by Vipère</a></iframe>';
  });//*/

  /* var player0 = document.getElementById('player0');
  player0.querySelector('picture').addEventListener('mouseover', function(){
    player0.innerHTML = '<span class="loader">Chargement en cours...</span><iframe title="90 piges by Vipère" style="border: 0; width: 100%; height: 42px;" src="https://bandcamp.com/EmbeddedPlayer/track=2686403651/size=small/bgcol=ffffff/linkcol=0687f5/transparent=true/" seamless><a href="https://vipereduo.bandcamp.com/track/90-piges" rel="noopener">90 piges by Vipère</a></iframe>';
  }); */

  /* var player00 = document.getElementById('player00');
  player00.querySelector('picture').addEventListener('mouseover', function(){
    player00.innerHTML = '<span class="loader">Chargement en cours...</span><iframe title="L\'envers de la médaille by Vipère" style="border: 0; width: 100%; height: 42px;" src="https://bandcamp.com/EmbeddedPlayer/track=4152171946/size=small/bgcol=ffffff/linkcol=0687f5/transparent=true/" seamless><a href="https://vipereduo.bandcamp.com/track/lenvers-de-la-m-daille" rel="noopener">L&#39;envers de la médaille by Vipère</a></iframe>';
  }); */

  /* var player01 = document.getElementById('player01');
  player01.querySelector('picture').addEventListener('mouseover', function(){
    player01.innerHTML = '<span class="loader">Chargement en cours...</span><iframe title="On en est là" style="border: 0; width: 100%; height: 42px;" src="https://bandcamp.com/EmbeddedPlayer/track=650357251/size=small/bgcol=ffffff/linkcol=0687f5/transparent=true/" seamless><a href="https://vipereduo.bandcamp.com/track/on-en-est-l" rel="noopener">On en est là by Vipère</a></iframe>';
  }); */

  /* var player02 = document.getElementById('player02');
  player02.querySelector('picture').addEventListener('mouseover', function(){
    player02.innerHTML = '<span class="loader">Chargement en cours...</span><iframe title="Paname Vs Paris" style="border: 0; width: 100%; height: 42px;" src="https://bandcamp.com/EmbeddedPlayer/track=855743925/size=small/bgcol=ffffff/linkcol=0687f5/transparent=true/" seamless><a href="https://vipereduo.bandcamp.com/track/paname-vs-paris" rel="noopener">Paname Vs Paris de Vipère</a></iframe>';
  }); */

  var player31 = document.getElementById('player31');
  player31.querySelector('picture').addEventListener('mouseover', function(){
    player31.innerHTML = '<span class="loader">Chargement en cours...</span><iframe title="Reflet" style="border: 0; width: 100%; height: 42px;" src="https://bandcamp.com/EmbeddedPlayer/album=2648663474/size=small/bgcol=ffffff/linkcol=0687f5/transparent=true/" seamless><a href="https://vipereduo.bandcamp.com/album/reflet">Reflet de Vipère</a></iframe>';
  });

  var player32 = document.getElementById('player32');
  player32.querySelector('picture').addEventListener('mouseover', function(){
    player32.innerHTML = '<span class="loader">Chargement en cours...</span><iframe title="Bagou" style="border: 0; width: 100%; height: 42px;" src="https://bandcamp.com/EmbeddedPlayer/album=2648663474/size=small/bgcol=ffffff/linkcol=0687f5/track=1657143969/transparent=true/" seamless><a href="https://vipereduo.bandcamp.com/album/reflet">Bagou de Vipère</a></iframe>';
  });

  var player33 = document.getElementById('player33');
  player33.querySelector('picture').addEventListener('mouseover', function(){
    player33.innerHTML = '<span class="loader">Chargement en cours...</span><iframe title="Les pensées mal-placées" style="border: 0; width: 100%; height: 42px;" src="https://bandcamp.com/EmbeddedPlayer/album=2648663474/size=small/bgcol=ffffff/linkcol=0687f5/track=325728358/transparent=true/" seamless><a href="https://vipereduo.bandcamp.com/album/reflet">Les pensées mal-placées de Vipère</a></iframe>';
  });

  var player34 = document.getElementById('player34');
  player34.querySelector('picture').addEventListener('mouseover', function(){
    player34.innerHTML = '<span class="loader">Chargement en cours...</span><iframe title="À bout portant" style="border: 0; width: 100%; height: 42px;" src="https://bandcamp.com/EmbeddedPlayer/album=2648663474/size=small/bgcol=ffffff/linkcol=0687f5/track=1205528895/transparent=true/" seamless><a href="https://vipereduo.bandcamp.com/album/reflet">À bout portant de Vipère</a></iframe>';
  });

  var player35 = document.getElementById('player35');
  player35.querySelector('picture').addEventListener('mouseover', function(){
    player35.innerHTML = '<span class="loader">Chargement en cours...</span><iframe title="Des trésors" style="border: 0; width: 100%; height: 42px;" src="https://bandcamp.com/EmbeddedPlayer/album=2648663474/size=small/bgcol=ffffff/linkcol=0687f5/track=2923407525/transparent=true/" seamless><a href="https://vipereduo.bandcamp.com/album/reflet">Des trésors de Vipère</a></iframe>';
  });

  var video = document.getElementById('playerVideo');
  video.querySelector('picture').addEventListener('click', function(){
    //video.innerHTML = '<span class="loader">Chargement en cours...</span><iframe title="Vidéo groupe Vipère" width="560" height="315" src="https://www.youtube.com/embed/cVVwzpw3Xyo?start=30&autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
    video.innerHTML = '<span class="loader">Chargement en cours...</span><iframe title="Vidéo groupe Vipère" width="560" height="315" src="https://www.youtube.com/embed/OfR5f50tMjI?autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
  });
}

var isPaused = true;
var videoSizes = [
  1080,
  720,
  480,
  360,
  240,
  144
];
//var videoBaseUrl = "https://vipere.zeclou.de";
var videoBaseUrl = "https://ch7h9aingw.preview.infomaniak.website";
function initVideos(){

  //* Create quality selector */
  var select = document.createElement('select');
  select.id = 'vQuality';

  //* Add sizes */
  videoSizes.forEach(function(size){
    var option = document.createElement('option');
    option.value = size;
    option.innerHTML = `${size}p`;
    select.append(option);
  });

  //* Add 'auto' as default value */
  var optionAuto = document.createElement('option');
  optionAuto.value = 'auto';
  optionAuto.innerHTML = `Auto`;
  select.append(optionAuto);
  select.value = 'auto';

  //* Append to a container */
  var selectContainer = document.createElement('div');
  selectContainer.className = 'video-quality';
  selectContainer.innerHTML = '<label for="vQuality">qualité vidéo</label> ';
  selectContainer.append(select);

  //* Append to the document */
  var container = document.querySelector('#video .container');
  container.append(selectContainer);

  //* Get the <video> element  and add eventListener on 'loadedmetadata'*/
  var video = document.getElementById('clip90piges');
  video.addEventListener('loadedmetadata', function(e){
    if(!isPaused) video.play();
  });

  //* Select change event */
  select.addEventListener('change', function(e){
    setVideoQuality(video, e.target.value);
  });


  //* Start with quality 'auto' */
  setTimeout(function(){
    setVideoQuality(video, 'auto');
  },1000);

  // Set video quality selon window width
  /*
  var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

  if(windowWidth >= 1100){
    setVideoQuality(720);
  }else if(windowWidth >= 700){
    setVideoQuality(720);
  }else{
    setVideoQuality(480);
  }//*/


}
function setVideoQualityByNetworkSpeedAndWindowWidth(video){
  var userImageLink = videoBaseUrl+"/speedtestimage.php";
  var time_start, end_time;

  // The size in bytes
  var downloadSize = 1845;
  var downloadImgSrc = new Image();

  time_start = new Date().getTime();
  downloadImgSrc.src = userImageLink;
  downloadImgSrc.onload = function () {
    end_time = new Date().getTime();

    // Calculate speed
    var timeDuration = (end_time - time_start);

    var windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    var maxSize = 144;
    if(windowWidth > 1080*(16/9)){
      maxSize = 1080;
    }else if(windowWidth > 720*(16/9)){
      maxSize = 720;
    }else if(windowWidth > 480*(16/9)){
      maxSize = 480;
    }else if(windowWidth > 360*(16/9)){
      maxSize = 360;
    }else if(windowWidth > 240*(16/9)){
      maxSize = 240;
    }

    var size = 1080;
    if(timeDuration > 3000){
      size =  maxSize>144 ? 144 : maxSize;
    }else if(timeDuration > 2000){
      size =  maxSize>240 ? 240 : maxSize;
    }else if(timeDuration > 1200){
      size =  maxSize>360 ? 360 : maxSize;
    }else if(timeDuration > 800){
      size =  maxSize>480 ? 480 : maxSize;
    }else if(timeDuration > 400){
      size = maxSize>720 ? 720 : maxSize;
    }else{
      size = maxSize>1080 ? 1080 : maxSize;
    }

    var width = size*(16/9);

    setVideoQuality(video, size);
  };

  return true;
}
function setVideoQuality(video, quality){

  // Find best suitable quality when 'auto'
  if(quality == 'auto'){
    setVideoQualityByNetworkSpeedAndWindowWidth(video);
    quality = 0;
  }

  // Get appropriate video size depends on 'quality'
  var parsedQuality = parseInt(quality);
  var videoSize = videoSizes.slice(-1)[0];
  videoSizes.reverse();
  videoSizes.forEach(function(size){
    if(parsedQuality >= size) videoSize = size;
  });
  videoSizes.reverse();

  // Get current video status and pause it if it's playing
  isPaused = video.paused ? true : false;
  //if(!isPaused) video.pause();

  // Get current video time position
  var currentTime = parseInt(video.currentTime);

  // Set up new video sources and load video
  video.querySelector('source[type="video/webm"]').src = `${videoBaseUrl}/videos/clip-90-piges-vipere-${videoSize}p.webm`;
  video.querySelector('source[type="video/mp4"]').src = `${videoBaseUrl}/videos/clip-90-piges-vipere-${videoSize}p.mp4`;
  video.load();

  // Position the video at the current time
  video.currentTime = currentTime;

  //*/
}

function initMicroModal(){
  
  MicroModal.init({
    onShow: (modal,trigger) => {
      initSlider(trigger.dataset.number);
    },
    onClose: (modal,trigger) => {
      window.mySwipe.kill();
    }
  });
}

function init(){
  initDropdown();
  initScrollSpy();
  initStuffs();
  initIframes();
  initVideos();
  initMicroModal();
}

document.addEventListener('DOMContentLoaded', init);
